export const PermissionsActiveDialog = {
  MEMBERS: "members",
  FACILITIES: "facilities",
  FACILITIES_GROUPS: "facilities-groups",
  PERMISSIONS: "permissions",
  PERMISSIONS_PREVIEW: "permissions-preview",
  COMPLETE: "complete"
};
